<template>
	<div class="rn-timeline-wrapper timeline-style-one position-relative">
		<div class="timeline-line" />

		<div id="menu">
			<span>{{timelineTitle}}</span>
			<ul>
				<li v-for="(timeline, index) in timelineData" :key="index"><a :href="`#tl_${timeline.id}`">{{timeline.title}}</a></li>
			</ul>
		</div>		

		<div :id="`tl_${timeline.id}`" class="single-timeline mt--50" v-for="(timeline, index) in timelineData" :key="index">
			<div class="timeline-dot">
				<div class="time-line-circle" />
			</div>
			<div class="single-content">
				<div class="inner">
					<div class="row row--30 align-items-center">
						<div class="order-2 order-lg-1 col-lg-6 mt_md--40 mt_sm--40">
							<div class="content">
								<span class="date-of-timeline" data-aos="fade-up" data-aos-delay="50">
									{{ timeline.date }}
								</span>
								<h2 class="title" data-aos="fade-up" data-aos-delay="80">
									{{ timeline.title }}
								</h2>
								<p class="description" data-aos="fade-up" data-aos-delay="110">
									<span v-html="timeline.description"></span>
								</p>

								<div class="row row--30">
									<div class="col-lg-6 col-md-6 col-12" v-for="(step, index) in timeline.workingStep"
										:key="index" data-aos="fade-up" data-aos-delay="140">
										<div class="working-list">
											<h5 class="working-title" data-aos="fade-up" data-aos-delay="60">
												{{ step.stepTitle }}
											</h5>
											<p data-aos="fade-up" data-aos-delay="60">
											    <span v-html="step.stepDescription"></span>
											</p>
										</div>
									</div>
								</div>
								<!-- <div class="read-morebtn">
									<a class="btn-default btn-large round" href="#" data-aos="fade-up"
										data-aos-delay="170">
										<span>Get Started Now</span>
									</a>
								</div> -->
							</div>
						</div>
						<div class="order-1 order-lg-2 col-lg-6">
							<div class="thumbnail" data-aos="fade-up">
								<img class="w-100" :src="require(`@/assets/images/edge/Active/实施案例页${timeline.image}`)"
									alt="Corporate Vue Template" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	

</template>

<script>
	import Icon from '../../icon/Icon'
	
	export default {
		name: 'Timeline',
		components:{Icon},
		props: {
			timelineTitle:'',
			timelineData: {},
			timelineStyle: {
				type: Number,
				default: 1
			}
		},
		computed: {
			checkTimelineStyle() {
				if (this.timelineStyle === 3) return 'no-gradient';
				else if (this.timelineStyle === 4) return 'dark-line';
				else return '';
			}
		}
	}
</script>

<style scoped>
	#menu {
		position: fixed;
		left: 10px;
		top: 50%;
		width: 8em;
		margin-top: -2.5em;
		z-index: 100;
	}

	#menu span{
		font-size: mediumc;
		font-weight: bold;
		color: black;
	}
	#menu li{
		font-size: small;		
		color: black;
		list-style:none !important;/* 让a标签前面没有点 */
	}
</style>
